import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnigdipradhikaran() {



const cardData = {
  keyword: " Cab Service in Nigdi Pradhikaran  ",

"headingDescription": "SRS Cab Service offers Cab Service in Nigdi Pradhikaran, providing reliable, safe, and comfortable transportation for daily commuting, business travel, airport transfers, and leisure trips. Our well-maintained vehicles, professional drivers, and punctual service ensure a smooth and hassle-free journey across Nigdi Pradhikaran and nearby areas. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service is your trusted partner for convenient and stress-free travel.",
"topPlaces": [
  {
    "title": "Durga Tekdi",
    "description": "Durga Tekdi is a popular green hill area in Nigdi known for its peaceful environment and scenic views. Travelers using Cab Service in Nigdi Pradhikaran from SRS Cab Service often visit for morning walks and relaxation."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar is a well-known amusement park offering rides and entertainment for families and children. Visitors using SRS Cab Service often include this spot for fun and recreation."
  },
  {
    "title": "Bhakti Shakti Garden",
    "description": "Bhakti Shakti Garden is a beautifully maintained park ideal for relaxation and family outings. Travelers using SRS Cab Service often enjoy its peaceful ambiance and greenery."
  },
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "Akkalkot Swami Samarth Mandir is a revered spiritual place attracting devotees. Visitors using SRS Cab Service often visit for blessings and spiritual experiences."
  },
  {
    "title": "PCMC Garden",
    "description": "PCMC Garden is a well-maintained park suitable for walks and leisure time. Travelers using SRS Cab Service often include it in their daily or weekend outings."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "This science park is an educational and family-friendly destination. Visitors using SRS Cab Service frequently visit for interactive learning and entertainment."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a busy shopping hub with local stores and eateries. Travelers using SRS Cab Service often explore this market for shopping and food."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and activities. Visitors using SRS Cab Service often come here for matches and fitness activities."
  },
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is a well-known religious site. Travelers using SRS Cab Service often visit to seek blessings and experience local traditions."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub near Nigdi Pradhikaran. Business travelers using SRS Cab Service frequently commute here for corporate and professional needs."
  }
],



services: [
{
name: "Cab Service in Nigdi Pradhikaran",
description: "Cab service in Nigdi Pradhikaran offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Nigdi Pradhikaran Cab Service",
description: "Nigdi Pradhikaran cab service provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Nigdi Pradhikaran",
description: "Taxi service in Nigdi Pradhikaran offers convenient transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Nigdi Pradhikaran Taxi Service",
description: "Nigdi Pradhikaran taxi service provides reliable transportation for local and long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Nigdi Pradhikaran",
description: "Cab booking Nigdi Pradhikaran offers quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Nigdi Pradhikaran",
description: "Taxi booking Nigdi Pradhikaran provides convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Nigdi Pradhikaran",
description: "Cab near Nigdi Pradhikaran helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Nigdi Pradhikaran",
description: "Taxi near Nigdi Pradhikaran offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Nigdi Pradhikaran",
description: "Best cab service in Nigdi Pradhikaran provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Nigdi Pradhikaran",
description: "Cheap cab service Nigdi Pradhikaran offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Nigdi Pradhikaran",
description: "Affordable cab service Nigdi Pradhikaran provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Nigdi Pradhikaran Cab Hire",
description: "Nigdi Pradhikaran cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Nigdi Pradhikaran Taxi Hire",
description: "Nigdi Pradhikaran taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Nigdi Pradhikaran Cab for Airport",
description: "Nigdi Pradhikaran cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Nigdi Pradhikaran Airport Cab Service",
description: "Nigdi Pradhikaran airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Nigdi Pradhikaran Cab for Outstation",
description: "Nigdi Pradhikaran cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Nigdi Pradhikaran Pune",
description: "Cab service Nigdi Pradhikaran Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Nigdi Pradhikaran Pune",
description: "Taxi service Nigdi Pradhikaran Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Nigdi Pradhikaran Pune",
description: "Cab booking Nigdi Pradhikaran Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
}
],

tableData: [
["Cab Service in Nigdi Pradhikaran","Nigdi Pradhikaran Cab Service"],
["Taxi Service in Nigdi Pradhikaran","Nigdi Pradhikaran Taxi Service"],
["Cab Booking Nigdi Pradhikaran","Taxi Booking Nigdi Pradhikaran"],
["Cab Near Nigdi Pradhikaran","Taxi Near Nigdi Pradhikaran"],
["Best Cab Service in Nigdi Pradhikaran","Cheap Cab Service Nigdi Pradhikaran"],
["Affordable Cab Service Nigdi Pradhikaran","Nigdi Pradhikaran Cab Hire"],
["Nigdi Pradhikaran Taxi Hire","Nigdi Pradhikaran Cab for Airport"],
["Nigdi Pradhikaran Airport Cab Service","Nigdi Pradhikaran Cab for Outstation"],
["Cab Service Nigdi Pradhikaran Pune","Taxi Service Nigdi Pradhikaran Pune"],
["Cab Booking Nigdi Pradhikaran Pune","Cab Service Nigdi Pradhikaran"]
],



whychoose: [
  {
    WhyChooseheading: "Local Expertise in Nigdi Pradhikaran Area",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service in Nigdi Pradhikaran with drivers familiar with local routes, Akurdi, Ravet, and nearby PCMC areas."
  },
  {
    WhyChooseheading: "Affordable Cab Service in Nigdi",
    WhyChoosedescription: "We offer budget-friendly cab services in Nigdi Pradhikaran with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Nigdi, making it convenient for daily travel, office commutes, airport transfers, and emergency bookings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride within Nigdi and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for all travel needs."
  },
  {
    WhyChooseheading: "Quick Pickup & Doorstep Service",
    WhyChoosedescription: "We provide fast pickup from homes, offices, societies, and commercial areas across Nigdi Pradhikaran and nearby locations."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite behavior, and reliable service for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Nigdi Pradhikaran",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and businesses in Nigdi for punctual service, affordable pricing, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Nigdi Pradhikaran?", answer: "Yes, SRS Cab Service offers reliable cab services in Nigdi Pradhikaran for local and outstation travel." },
  { question: "Is cab service available 24 hours in Nigdi?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Nigdi?", answer: "Yes, we provide Pune Airport pickup and drop services from Nigdi Pradhikaran." },
  { question: "Which areas do you cover near Nigdi?", answer: "We cover Akurdi, Ravet, Chinchwad, Pimpri, and nearby PCMC areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book cab online in Nigdi?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way and outstation cab?", answer: "Yes, we provide one-way and outstation cab services from Nigdi Pradhikaran." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback:
      "Booked cab from Nigdi to airport. Very quick pickup and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Nigdi Pradhikaran. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];





















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Nigdi Pradhikaran Cab Service | SRS Cab Service",
  "description": "Reliable and affordable cab service in Nigdi Pradhikaran, Pune. Offering local rides, airport transfers, and outstation trips with Innova, Ertiga, Dzire, Sedan, and Tempo Traveller cabs. 24/7 taxi service for corporate and personal travel.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Nigdi Pradhikaran",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411044",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6241",
    "longitude": "73.7983"
  },
  "url": "https://www.srscabservice.com/nigdi-pradhikaran-cab-service",
  "areaServed": [
    "Nigdi Pradhikaran", "Chinchwad", "Pimpri", "Akurdi", "Bhosari"
  ],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Nigdi Pradhikaran Cab Service",
    "Local and Outstation Cabs",
    "Airport Transfers",
    "Innova, Ertiga, Dzire, Sedan, Tempo Traveller Hire"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "510"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Nigdi Pradhikaran Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book reliable cabs in Nigdi Pradhikaran, Pune. Affordable Innova, Ertiga, Dzire, Sedan, and Tempo Traveller cabs for local rides, airport transfers, and outstation trips. 24/7 taxi service for corporate and personal travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnigdipradhikaran;